import { render, staticRenderFns } from "./ViewInvoice.vue?vue&type=template&id=680eb4bc&scoped=true&"
import script from "./ViewInvoice.vue?vue&type=script&lang=js&"
export * from "./ViewInvoice.vue?vue&type=script&lang=js&"
import style0 from "./ViewInvoice.vue?vue&type=style&index=0&id=680eb4bc&lang=scss&scoped=true&"
import style1 from "./ViewInvoice.vue?vue&type=style&index=1&id=680eb4bc&scoped=true&lang=css&"
import style2 from "./ViewInvoice.vue?vue&type=style&index=2&id=680eb4bc&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "680eb4bc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('680eb4bc')) {
      api.createRecord('680eb4bc', component.options)
    } else {
      api.reload('680eb4bc', component.options)
    }
    module.hot.accept("./ViewInvoice.vue?vue&type=template&id=680eb4bc&scoped=true&", function () {
      api.rerender('680eb4bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sales/invoices/ViewInvoice.vue"
export default component.exports